/* eslint-disable */
import { sortBy } from "lodash"


export enum ContentCreatorType {
    PODCAST = "PODCAST",
    TOOL = "TOOL",
    WEBAPP = "WEBAPP",
    STREAMER = "STREAMER",
    WRITER = "WRITER",
    ONLINE_LEAGUE = "ONLINE_LEAGUE",
    OTHER = "OTHER",
}

export class ContentCreatorTypeUtils {
    static readonly values = [ContentCreatorType.PODCAST, ContentCreatorType.TOOL, ContentCreatorType.WEBAPP, ContentCreatorType.STREAMER, ContentCreatorType.WRITER, ContentCreatorType.ONLINE_LEAGUE, ContentCreatorType.OTHER]
    static valueOf = (value: string) => ContentCreatorTypeUtils.values.find(enumValue => enumValue === value)
    static sort = (value: ContentCreatorType[]) => sortBy(value, expansion => ContentCreatorTypeUtils.values.indexOf(expansion))
}